import { render, staticRenderFns } from "./DragListTopic.vue?vue&type=template&id=1034f3df&scoped=true&"
import script from "./DragListTopic.vue?vue&type=script&lang=ts&"
export * from "./DragListTopic.vue?vue&type=script&lang=ts&"
import style0 from "./DragListTopic.vue?vue&type=style&index=0&id=1034f3df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1034f3df",
  null
  
)

component.options.__file = "DragListTopic.vue"
export default component.exports